import { ProductVariant } from 'types/Product';
import { stringContainsOnlyAlphanumericCharacters } from 'utilities/util';

export default function findSkuByOption(option: string, skus: ProductVariant[]) {
  const isOptionValid = stringContainsOnlyAlphanumericCharacters(option);

  if (!isOptionValid) return undefined;

  return skus.find((sku) => sku.option === option);
}

export function findSkuByOptionList(variants: ProductVariant[], optionList: Record<string, string>): ProductVariant {
  let filteredVariants = variants;
  Object.entries(optionList).forEach(([optionKey, optionValue]) => {
    filteredVariants = filteredVariants.filter(
      (variant) => variant.options[optionKey as keyof typeof variant.options] === optionValue,
    );
  });
  return filteredVariants[0];
}
